module.exports = __webpack_public_path__ + "img/CrueInvest.ccb2a34b.png";